<template>
  <div>
    <h2>{{hasRecord}}阀门开关记录</h2>
    <Spin fix v-show="isSpinShow">
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <Scroll :height="height * 0.9" :on-reach-bottom="handleReachEdge" :distance-to-edge="[100,1]">
      <Table id="recordTable" ref="recordTable" border :columns="recordColumns" :data="records"></Table>

      <p>上滑加载</p>
    </Scroll>
  </div>
</template>
<script>
export default {
  mounted() {},
  data() {
    return {
      meterId: "",
      height: document.body.clientHeight,
      width: document.body.clientWidth,
      recordColumns: [],
      records: [],
      formatObject: {},
      pageSize: 40,
      pageNo: 1,
      hasRecord: "",
      isSpinShow: false
    };
  },
  methods: {
    clearData() {
      this.recordColumns = [];
      this.records = [];
      this.formatObject = {};
      this.pageNo = 1;
    },
    getvalveRecord() {
      var that = this;
      that.isSpinShow = true;
      that.hasRecord = "";
      $.ajax({
        url:
          "/api/instructions/searchUpInstructions?page=" +
          that.pageNo +
          "&pageAmount=" +
          that.pageSize,
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          commandDeviceId: that.meterId,
          commandType: "0x84",
          page: that.pageNo,
          pageAmount: that.pageSize
        }),
        dataType: "json",
        success: function(receiveData) {
          if (receiveData.body == null) {
            return;
          }

          if (receiveData.body.resultList.length == 0) {
            if (that.records.length == 0) {
              that.hasRecord = "暂无";
            }
            return;
          }

          var columns = receiveData.body.columns;
          var dataList = receiveData.body.resultList;

          that.recordColumns = [];

          columns.forEach(function(value, i) {
            if (value.title != "时间") {
              that.recordColumns.push(columns[i]);
            }
          });
          dataList.forEach(function(value, i) {
            let opentime = value.openTime;
            let closetime = value.closeTime;
            let commandtimestamp = value.commandTimestamp;

            // value.openTime = global.dateFtt(
            //   "hh:mm:ss",
            //   new Date(opentime.replace(/\-/g, "/"))
            // );
            // value.closeTime = global.dateFtt(
            //   "hh:mm:ss",
            //   new Date(closetime.replace(/\-/g, "/"))
            // );
            // value.commandTimestamp = global.dateFtt(
            //   "yyyy-MM-dd",
            //   new Date(commandtimestamp.replace(/\-/g, "/"))
            // );

            value.openTime = global.dateFtt(
              "yy-MM-dd hh:mm:ss",
              new Date(opentime.replace(/\-/g, "/"))
            );

            value.openTime == "" ? (value.openTime = "未记录有效时间") : true;

            value.closeTime = global.dateFtt(
              "yy-MM-dd hh:mm:ss",
              new Date(closetime.replace(/\-/g, "/"))
            );

            value.closeTime == "" ? (value.closeTime = "未记录有效时间") : true;

            value.commandTimestamp = global.dateFtt(
              "yyyy-MM-dd",
              new Date(commandtimestamp.replace(/\-/g, "/"))
            );
            that.records.push(value);
          });
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.isSpinShow = false;
        }
      });
    },
    handleReachEdge(dir) {
      return new Promise(resolve => {
        if (dir > 0) {
        } else {
          this.pageNo = this.pageNo + 1;
          this.getvalveRecord();
        }
        resolve();
      });
    }
  }
};
</script>
<style scoped>
#recordTable /deep/ .ivu-table {
  font-size: 16px;
}

.collapse {
  margin: 5px;
  background-color: white;
  text-align: left;
  font-size: 16px;
}

.panel {
  font-weight: 800;
  font-family: "SimSun";
  font-size: 16px;
}
.row {
  margin: 5px;
}
.ivu-collapse-content {
  padding: 0;
}
</style>

